module.exports = __webpack_public_path__ + "img/single-player.b13c84dc.png";